import api from '@/api';

import { PageRequest } from '@/core/request/PageRequest';

import { API_BASE_URL } from '..';
import {
  CreateSupplierContactsRequest,
  SupplierContacts,
} from './SupplierContact.types';

const CONTROLLER_URL = `${API_BASE_URL}/suppliers`;

export async function listSupplierContacts(
  supplierId: number,
  params?: PageRequest,
) {
  const result = (await api.get(
    `${CONTROLLER_URL}/${supplierId}/contacts`,
    params,
  )) as unknown;
  return result as SupplierContacts[];
}

export async function createSupplierContacts(
  obj: CreateSupplierContactsRequest,
  supplierId: number,
) {
  const result = (await api.post(
    `${CONTROLLER_URL}/${supplierId}/contacts`,
    obj,
    null,
  )) as unknown;
  return result as SupplierContacts;
}

export async function updateSupplierContact(
  obj: CreateSupplierContactsRequest,
  id: number,
  supplierId: number,
) {
  const result = (await api.put(
    `${CONTROLLER_URL}/${supplierId}/contacts/${id}`,
    obj,
    null,
  )) as unknown;

  return result as SupplierContacts;
}

export async function removeSupplierContact(
  supplierId: number,
  contactId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${supplierId}/contacts/${contactId}`,
    {},
    null,
  )) as unknown;

  return result as void;
}

export async function removeSupplierDetailContact(
  supplierId: number,
  detailId: number,
) {
  const result = (await api.remove(
    `${CONTROLLER_URL}/${supplierId}/contacts/contactDetail/${detailId}`,
    {},
    null,
  )) as unknown;

  return result as void;
}
